import { ComponentPropsWithoutRef } from 'react'
import { Link } from 'react-router-dom'
import style from './a.module.css'

type Props =
    | ({ external: true } & ComponentPropsWithoutRef<'a'>)
    | ({ external?: false } & ComponentPropsWithoutRef<typeof Link>)

const A = (props: Props) => {
    if (props.external) {
        const { className = '', external, children, ...rest } = props

        return (
            <a className={style[className] || className} {...rest}>
                {children}
            </a>
        )
    }

    const { className = '', external, children, ...rest } = props

    return (
        <Link className={style[className] || className} {...rest}>
            {children}
        </Link>
    )
}

export default A
